import {useState} from 'react'
import{  FiMessageCircle, FiStar, FiHeart, FiBookmark, FiRepeat, FiShare } from'react-icons/fi'
 import { BsThreeDots } from 'react-icons/bs';
import {Persons} from './persons'
import {Images} from './images'

export const Project = ({ images, team, heart, data, hearted }) => {

    const [favorite, setFavorite] = useState(hearted);
    const toggleFavorite = () => setFavorite(!favorite);

    return (
        <div className="project">
            <div className="project-actions">
                <div>
                    <img src="/assets/images/bg/facetoface.png" className="projects-logo" alt="" />
                    <div className="project-info">
                        <h3 className="bold"><div>The Brand</div></h3>
                        <div className="bold desc">@brand</div>
                    </div>
                </div>

                <div className="project-opts">
                    <FiStar />
                    <FiBookmark />


                    <FiHeart className={favorite && 'hearted'} onClick={toggleFavorite} />
                    <div className="project-opt">
                        <BsThreeDots />
                    </div>
                </div>


            </div>
            <div className="project-text">
                {data ? <div><p className="project-title">{data.title}</p> <p>{data.desc}</p> </div> : <p>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nesciunt iusto magnam praesentium eos
                     <div>https://short.link/2507</div></p>}

                {!team ? images ? <Images /> : <img src="/assets/images/projects/2.jpg" className="project-img" alt="" />

                    : <Persons />}

            </div>
            <div className="project-activity">
                {heart && <div><div> <FiHeart className="fill-red" />  <p>2.528</p></div></div>}
                <div><div> <FiMessageCircle /> <p>125</p></div></div>
                {!heart && <div><div> <FiHeart />  <p>2.528</p></div></div>}
                <div><div> <FiRepeat /> <p>2501</p></div></div>
                <div><div><p>View</p> <FiShare /></div></div>
            </div>

        </div>

    )
}